/**
 * ViewToggle — tiles ⇄ list, for the admin catalogue only (brief-26).
 *
 * A list row drops the icon mark, the full description and the pricing emphasis
 * the storefront card is built around, so storefront modes keep cards and never
 * render this control (decision: Stephan, 2026-07-25).
 */

import { t } from '../i18n';
import type { CatalogView } from '../hooks/useCatalogPrefs';

interface ViewToggleProps {
  view: CatalogView;
  onChange: (view: CatalogView) => void;
}

export default function ViewToggle({ view, onChange }: ViewToggleProps) {
  const options = [
    { value: 'tiles' as const, label: t('catalog.view.tiles'), mark: '▦' },
    { value: 'list' as const,  label: t('catalog.view.list'),  mark: '☰' },
  ];

  return (
    <div className="dp-viewtoggle" role="group" aria-label={t('catalog.view.label')}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={`dp-viewtoggle__btn${view === o.value ? ' dp-viewtoggle__btn--on' : ''}`}
          aria-pressed={view === o.value}
          onClick={() => onChange(o.value)}
        >
          <span aria-hidden="true">{o.mark}</span>
          <span>{o.label}</span>
        </button>
      ))}
    </div>
  );
}
